import { render, staticRenderFns } from "./title-wheel.vue?vue&type=template&id=1d80e478&scoped=true&"
import script from "./title-wheel.vue?vue&type=script&lang=js&"
export * from "./title-wheel.vue?vue&type=script&lang=js&"
import style0 from "./title-wheel.vue?vue&type=style&index=0&id=1d80e478&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d80e478",
  null
  
)

export default component.exports